import type { DriveStep } from "driver.js";
import { ONBOARDING_IDS } from "../constants";

export const teamProfileSteps: DriveStep[] = [
    {
        element: `#${ONBOARDING_IDS.TEAM_PROFILE_HEADER}`,
        popover: {
            title: "Team Identity",
            description:
                "The header shows the team logo, full name, and the currently selected tournament. " +
                "All sub-pages below display data for this specific team and tournament.",
            side: "bottom",
            align: "start",
        },
    },
    {
        element: `#${ONBOARDING_IDS.TEAM_PROFILE_NAV}`,
        popover: {
            title: "Team Sections",
            description:
                "Navigate between five sections — Overview, Players, Tournament Analysis, Compare, and H2H Line Compare — " +
                "each offering a different lens on the team's performance.",
            side: "bottom",
            align: "start",
        },
    },
    {
        element: `#${ONBOARDING_IDS.TEAM_PROFILE_METRICS}`,
        onHighlightStarted: (el) => el?.scrollIntoView({ behavior: "smooth", block: "nearest" }),
        popover: {
            title: "KPI Summary",
            description:
                "The top panel summarises the team's key KPI scores for the selected tournament — Total, Average, Player, and Goalie indicators.",
            side: "bottom",
            align: "start",
        },
    },
    {
        element: `#${ONBOARDING_IDS.TEAM_PROFILE_GAMES_SUMMARY}`,
        onHighlightStarted: (el) => el?.scrollIntoView({ behavior: "smooth", block: "nearest" }),
        popover: {
            title: "Games Summary",
            description:
                "A quick breakdown of wins, draws, and losses for the tournament, giving you an instant read of the team's overall form.",
            side: "left",
            align: "start",
        },
    },
    {
        element: `#${ONBOARDING_IDS.TEAM_PROFILE_TOP_PERFORMERS}`,
        onHighlightStarted: (el) => el?.scrollIntoView({ behavior: "smooth", block: "center" }),
        popover: {
            title: "Top Performers",
            description:
                "Highlights the team's highest-rated players for this tournament. " +
                "Click a player's name to jump straight to their individual profile.",
            side: "right",
            align: "start",
        },
    },
    {
        element: `#${ONBOARDING_IDS.TEAM_PROFILE_RECENT_GAMES}`,
        onHighlightStarted: (el) => el?.scrollIntoView({ behavior: "smooth", block: "center" }),
        popover: {
            title: "Recent Games",
            description:
                "A chronological list of the team's most recent matches with the final score and KPI result for each.",
            side: "left",
            align: "start",
        },
    },
    {
        element: `#${ONBOARDING_IDS.TEAM_PROFILE_HOME_AWAY}`,
        onHighlightStarted: (el) => el?.scrollIntoView({ behavior: "smooth", block: "center" }),
        popover: {
            title: "Tournament Standings & Home vs Away",
            description:
                "Two tabs in one panel. The first tab shows the full tournament standings table with points, wins, losses, and goal difference. " +
                "Switch to the second tab to compare the team's KPI averages at home versus on the road — " +
                "useful for spotting whether the team performs differently depending on venue.",
            side: "left",
            align: "start",
        },
    },
];
